<template>
	<div class="hello">
		<!-- <b-navbar toggleable="lg" type="dark" fixed="top"  :class="searchBarFixed ? 'isFixed' :''"> -->
		<b-navbar toggleable="lg" type="dark" fixed="top" class="topBg" >
			<b-navbar-brand href="/">
				<img :width="windowWidth > 768 ? 145 : 100" src="../../static/img/index/ic_newlogo.png" />
			</b-navbar-brand>
			<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
			<b-collapse id="nav-collapse" is-nav target="nav-collapse" v-show="isShow">
				<b-navbar-nav class="ml-auto" small>
					<b-nav-item v-for="(item, index) in menuList" :key="index" @click.stop="gotoPage(index, item)"><span
							:class="{ active: index == k }">{{ $t('head.' + item.label) }}</span></b-nav-item>
				</b-navbar-nav>
				<span class="lanBox">
					<el-button :class="lan == 'zh' ? 'text-bold' : 'text-white'" type="text"
						@click="changeLan('zh')">简体</el-button> |
					<el-button :class="lan == 'en' ? 'text-bold' : 'text-white'" type="text"
						@click="changeLan('en')">EN</el-button>
				</span>
			</b-collapse>
		</b-navbar>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isShow: true,
			windowWidth: window.innerWidth,
			searchBarFixed: false,
			k: 0,
			menuList: [
				{
					label: 'home',
					path: '/',
				},
				{
					label: 'about',
					path: '/about',
				},
				{
					label: 'news',
					path: '/news',
				},
				{
					label: 'service',
					path: '/service',
				},
				// {
				// 	label: 'yueniyou',
				// 	path: '/function',
				// },
				// {
				// 	label: '房车驿站',
				// 	path: '/stage',
				// },
				{
					label: 'theme',
					path: '/media',
				},
				{
					label: 'view',
					path: '/view',
				},

			],
			lan: 'zh'
		};
	},
	methods: {
		changeLan(lan) {//语言切换
			this.lan = lan;
			this.$i18n.locale = lan
		},
		abc(){
			alert(1)
		},
		gotoPage(index, item) {
			this.k = index;
			sessionStorage.removeItem("tabCur");
			this.$router.push(item.path);
			if (this.windowWidth <= 768) {
				this.isShow = false
			}
		},
		handleScroll() {
			var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			scrollTop > 380 ? (this.searchBarFixed = true) : (this.searchBarFixed = false);
			var activeColor = document.querySelector('.active');
			console.log('scrollTop',scrollTop);
		},
	},
	created() { },
	beforeCreate() { },
	// beforeMount() {
	// 	let id = this.$route.query.index;
	// 	this.k = id;
	// },
	mounted() {
		window.addEventListener('scroll', this.handleScroll);
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
.navbar-dark .navbar-nav .nav-link {
	font-size: 16px !important;
}

h1,
h2 {
	font-weight: normal;
}

ul {
	list-style-type: none;
	padding: 0;
}

.active {
	color: #fff !important;
	font-weight: bold;
}

li {
	display: inline-block;
	margin: 0 10px;
}

a {
	color: #42b983;
}

.navbar-dark .navbar-nav .nav-link {
	font-size: 14px;
}

@media (max-width: 768px) {
	.fixed-top {
		// background: #fff;
		background-color: rgba(0, 0, 0, 0.5);
	}

	.navbar {
		// padding: 0rem 1rem;
	}

	// }

	// @media (max-width: 576px) {
	.navbar {
		padding: 5px 10px !important;
	}

	.navbar-collapse {
		// background-color: rgba(0, 0, 0, 0.85);
		height: 100vh;
	}

	.navbar-toggler {
		font-size: 0.8rem;
		outline: none;
	}
}

@media (min-width: 768px) {
	.fixed-top {
		padding: 5px 240px;
	}

	.topBg {
		background-color: rgba(0, 0, 0, 0.3);
	}

	.isFixed {
		background: #42b983;
	}

	.lanBox {
		margin-left: 30px;
		font-size: 16px;
		color: #fff;

		button {
			outline: none;
			margin-left: 0;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/cx-head.vue